import Ventana from "../../../isp._comun/iu/_principal/reductores/Ventana";
import { DialogType, ModosOp } from "../../../isp._comun/iu/_principal/constantesIuPrin";
import getEstadoInicial from "../EstadoDialogoContrato";

export default class VentanaContrato extends Ventana {
    constructor(estadoComp) {
        super();
        this.id= DialogType.CONTRATO+estadoComp.domain.screen.idCliente;
        this.estadoComp = estadoComp;
        // this.dispatch = null;
        // this.ventanaCargando=null
    }

    static nuevaVentanaEnModoCrear() {
        return new VentanaContrato(getEstadoInicial());
    }

    static nuevaVentanaEnModoOk(idCliente) {
        const estadoComp = getEstadoInicial();
        estadoComp.flag.modoOperacion = ModosOp.OK;
        estadoComp.domain.screen.idCliente = idCliente;
        estadoComp.flag.modal = true;
        estadoComp.flag.cargandoEntidad = true;
        return new VentanaContrato(estadoComp);
    }

    puedeHacersePasarPor(ventanaAAbrir) {
        if (!(ventanaAAbrir instanceof VentanaContrato)) {
            return false;
        }

        if(this.id === ventanaAAbrir.id){
            return true;
        }

        return false;
    }

    clonar() {
        const nuevaVentana = new VentanaContrato(this.estadoComp);
        nuevaVentana.posicionZ = this.posicionZ;
        return nuevaVentana;
    }
}
